import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {
  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <div className="hero-tag">
            <span>Plataforma de Educação</span>
          </div>
          
          <h1>
            Transforme Seu Negócio com
            <br />
            <span className="highlight">Treinamento de Elite</span>
          </h1>
          
          <p className="hero-subtitle">
            Aprenda vendas e empreendedorismo com quem realmente entende do assunto.
            Cursos práticos, diretos e focados em resultados.
          </p>
          
          <div className="hero-buttons">
            <Link to="/register" className="btn-hero btn-primary-hero">
              Começar Agora
            </Link>
            <Link to="/login" className="btn-hero btn-outline-hero">
              Já tenho conta
            </Link>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats-home-section">
        <div className="stats-home-grid">
          <div className="stat-home-item">
            <div className="stat-home-number">500+</div>
            <div className="stat-home-label">Alunos Ativos</div>
          </div>
          <div className="stat-home-item">
            <div className="stat-home-number">15+</div>
            <div className="stat-home-label">Cursos Disponíveis</div>
          </div>
          <div className="stat-home-item">
            <div className="stat-home-number">98%</div>
            <div className="stat-home-label">Satisfação</div>
          </div>
          <div className="stat-home-item">
            <div className="stat-home-number">24/7</div>
            <div className="stat-home-label">Suporte</div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
